module.exports = __webpack_public_path__ + "static/media/safely_home.201dd938.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/safely_home.png
// module id = 326
// module chunks = 0